import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import Popup from "reactjs-popup";
import { CostEstimateRowsCalculator } from "../services/costEstimateRowsService";
import { acceptTender, declineTender } from "../services/sharedTendersService";
import { saveTenderAsPdf, saveOrderAsPdf } from "../services/createPdfService";

function Interval(props) {
    if (props.columnIndex === 0) {
        return props.multiplier;
    }

    return props.column.get(props);
}

class Tender extends Component {
    popupStyle = {
        background: "transparent none",
        border: "none",
        borderRadius: "4px",
        padding: "0"
    };

    handleAcceptTender = event => {
        event.preventDefault();
        const { hash } = this.props;
        const {
            contactEmail,
            contactName,
            note,
            purchaseNumber,
            quantity
        } = this.state;
        const data = {
            contactEmail,
            contactName,
            note,
            purchaseNumber,
            quantity
        };
    };

    handleChangeDeclineReason = event => {
        const declineReason = event.target.value;
        this.setState({
            declineReason
        });
    };

    handleChangeApproveTerms = event => {
        this.setState({
            approveTerms: event.target.checked
        });
    };

    handleChangeQuantity = event => {
        this.setState({
            quantity: event.target.value
        });
    };

    handleDeclineTender = event => {
        event.preventDefault();
        const { hash } = this.props;
        const message = this.declineReasonTextInput.current.value;
        declineTender(hash, message);
    };

    handleTextInputChange = (name, event) => {
        event.preventDefault();
        this.setState({
            [name]: event.target.value
        });
    };

    handleClickAccept = event => {
        event.preventDefault();
        this.setState({
            openAcceptPopup: true,
            openDeclinePopup: false,
            openMessagePopup: false
        });
    };

    handleClickPrint = event => {
        if (document.getElementById('tenderRows')) {
            const productInfoTable = document.getElementById('tenderRows').getElementsByTagName('table')[0].outerHTML;
            saveTenderAsPdf(this.props.hash, productInfoTable, 'Offert_' + this.props.costEstimateNumber + '.pdf');
        } else {
            const productInfoTable = document.getElementById('orderRows').getElementsByTagName('table')[0].outerHTML;
            saveOrderAsPdf(this.props.hash, productInfoTable, 'Orderbekräftelse_' + this.props.costEstimateNumber + '.pdf');
        }

        event.preventDefault();
    };

    handleClickDecline = event => {
        event.preventDefault();
        this.setState({
            openAcceptPopup: false,
            openDeclinePopup: true,
            openMessagePopup: false
        });
    };

    handleClickMessage = event => {
        event.preventDefault();
        this.setState({
            openAcceptPopup: false,
            openDeclinePopup: false,
            openMessagePopup: true
        });
    };

    handleClosedPopup = name => {
        this.setState({
            [name]: false
        });
    };

    constructor(props) {
        super(props);

        let { contact } = props;
        const approveTerms = false;
        const contactEmail = contact.email;
        const contactName = contact.firstname + " " + contact.lastname;
        const declineReason = 0;
        const note = "";
        const openAcceptPopup = false;
        const openDeclinePopup = false;
        const openMessagePopup = false;
        const purchaseNumber = "";
        const quantity = null;

        this.declineReasonTextInput = React.createRef();
        this.acceptTenderIFrame = React.createRef();
        this.declineTenderIFrame = React.createRef();
        this.messageIFrame = React.createRef();

        this.headings = [
            {
                get: multiplier => multiplier,
                heading: "Antal",
                name: "quantity"
            },
            // {
            //     get: props => {
            //         return CostEstimateRowsCalculator.getTotalM2Area(props);
            //     },
            //     heading: "m2",
            //     name: "totalM2"
            // },
            {
                get: props => {
                    return CostEstimateRowsCalculator.getTotalWeight(props);
                },
                heading: "Vikt i kg",
                name: "totalWeight"
            },
            {
                get: props => {
                    var price = Number(
                        CostEstimateRowsCalculator.getTotalUnitPrice(props)
                    );

                    if (CostEstimateRowsCalculator.getTotalDiscount(this.props) == 0) {
                        window.chartValues.push(price);
                        window.chartLabels.push(props.multiplier);
                    }

                    return price.toSek();
                },
                heading: "Pris/st",
                name: "undefined"
            },
            {
                get: props => {
                    return Number(
                        CostEstimateRowsCalculator.getTotalPrice(props)
                    ).toSek();
                },
                heading: "Pris",
                name: "undefined"
            }
        ];

        if (CostEstimateRowsCalculator.getTotalDiscount(this.props) > 0) {
            this.headings = [
                ...this.headings,
                {
                    get: props => {
                        return (
                            CostEstimateRowsCalculator.getTotalDiscount(props) +
                            "%"
                        );
                    },
                    heading: "Rabatt",
                    name: "undefined"
                },
                {
                    get: props => {
                        var price = Number(
                            CostEstimateRowsCalculator.getTotalUnitPriceAfterDiscount(
                                props
                            )
                        );

                        window.chartValues.push(price);
                        window.chartLabels.push(props.multiplier);

                        return price.toSek();
                    },
                    heading: "Pris/st",
                    name: "undefined"
                }
            ];
        }

        this.headings = [
            ...this.headings,
            {
                get: props => {
                    return Number(
                        CostEstimateRowsCalculator.getTotalPriceAfterDiscount(
                            props
                        )
                    ).toSek();
                },
                heading: "Slutpris",
                name: "undefined"
            }
        ];

        this.state = {
            approveTerms,
            contactEmail,
            contactName,
            declineReason,
            note,
            openAcceptPopup,
            openDeclinePopup,
            openMessagePopup,
            purchaseNumber,
            quantity
        };
    }

    componentDidMount() {
        window.displayChart();
    }

    renderActions() {
        const { customerAcceptedDate, customerRejectedDate } = this.props;
        let buttons = null;

        if (customerAcceptedDate || customerRejectedDate) {
            buttons = (
                <Fragment>
                    <button
                        className="btn btn-icon btn-icon--message"
                        onClick={event => this.handleClickMessage(event)}
                    >Meddela</button>
                    <button
                        className="btn btn-icon btn-icon--tender ml-4 js-createPdfClickReceiver"
                        onClick={event => this.handleClickPrint(event)}
                    >Skriv ut</button>
                </Fragment>
            );
        } else {
            buttons = (
                <Fragment>
                    <button
                        className="btn btn-icon btn-icon--decline btn-danger"
                        onClick={event => this.handleClickDecline(event)}
                    >
                        Avböj
                    </button>
                    <button
                        className="btn btn-icon btn-icon--message ml-4"
                        onClick={event => this.handleClickMessage(event)}
                    >
                        Meddela
                    </button>
                    <button
                        className="btn btn-icon btn-icon--tender ml-4 js-createPdfClickReceiver"
                        onClick={event => this.handleClickPrint(event)}
                    >
                        Skriv ut
                    </button>
                    <button
                        className="btn btn-icon btn-icon--order ml-4 btn-success"
                        onClick={event => this.handleClickAccept(event)}
                    >
                        Beställ
                    </button>
                </Fragment>
            );
        }

        return (
            <div className="row">
                <div className="col text-right">{buttons}</div>
            </div>
        );
    }

    render() {
        const {
            acceptTenderIFrameSrc,
            declineTenderIFrameSrc,
            messageTenderIFrameSrc,
            quantities
        } = this.props;
        const {
            openAcceptPopup,
            openDeclinePopup,
            openMessagePopup
        } = this.state;

        const acceptIframeContentsHeight = 925;
        const acceptTenderDialogueHeight = window.innerHeight < acceptIframeContentsHeight + 100 ? window.innerHeight - 200 : acceptIframeContentsHeight-200;

        return (
            <Fragment>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            {this.headings.map((column, index) => (
                                <th key={index} className="text-right">
                                    {column.heading}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {quantities.map((multiplier, rowIndex) => {
                            const rows = [...this.props.rows];
                            Object.keys(rows).forEach(key => {
                                const row = { ...rows[key] };
                                row["quantity"] = parseFloat(row["quantity"]); // * multiplier;
                                rows[key] = row;
                            });
                            const data = {
                                multiplier,
                                rows
                            };

                            return (
                                <tr key={rowIndex}>
                                    {this.headings.map(
                                        (column, columnIndex) => {
                                            return (
                                                <td
                                                    key={columnIndex}
                                                    className="text-right"
                                                >
                                                    <Interval
                                                        column={column}
                                                        columnIndex={
                                                            columnIndex
                                                        }
                                                        data={data}
                                                        multiplier={multiplier}
                                                        rowIndex={rowIndex}
                                                        rows={rows}
                                                    />
                                                </td>
                                            );
                                        }
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {this.renderActions()}
                <Popup
                    closeOnDocumentClick
                    contentStyle={this.popupStyle}
                    modal
                    onClose={() => this.handleClosedPopup("openAcceptPopup")}
                    open={openAcceptPopup}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Beställ
                            </header>
                            <div className="content p-0 hideVerticalScrollbar">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height={acceptTenderDialogueHeight}
                                        ref={this.acceptTenderIFrame}
                                        src={acceptTenderIFrameSrc}
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
                <Popup
                    closeOnDocumentClick
                    contentStyle={this.popupStyle}
                    modal
                    onClose={() => this.handleClosedPopup("openDeclinePopup")}
                    open={openDeclinePopup}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Avböjer offerten
                            </header>
                            <div className="content p-0">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height="400"
                                        ref={this.declineTenderIFrame}
                                        src={declineTenderIFrameSrc}
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
                <Popup
                    closeOnDocumentClick
                    contentStyle={this.popupStyle}
                    modal
                    onClose={() => this.handleClosedPopup("openMessagePopup")}
                    open={openMessagePopup}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Meddela säljaren
                            </header>
                            <div className="content p-0">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height="400"
                                        ref={this.messageTenderIFrameSrc}
                                        src={messageTenderIFrameSrc}
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
            </Fragment>
        );
    }
}

if (window.tenderSettings) {

    const t = window.tenderSettings;
    ReactDOM.render(
        <Tender
            acceptTenderIFrameSrc={t.data.acceptTenderIFrameSrc}
            contact={t.data.contact}
            costEstimateId={t.data.costEstimateId}
            costEstimateNumber={t.data.costEstimateNumber}
            customerAcceptedDate={t.data.customerAcceptedDate}
            customerRejectedDate={t.data.customerRejectedDate}
            date={t.data.date}
            declineTenderIFrameSrc={t.data.declineTenderIFrameSrc}
            messageTenderIFrameSrc={t.data.messageTenderIFrameSrc}
            deliveryDays={t.data.deliveryDays}
            hash={t.data.hash}
            name={t.data.name}
            quantities={t.data.quantities}
            customer={t.data.customer}
            rows={t.data.rows}
        />,
        t.settings.target
    );
}
